<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch06">
<a id="page34"></a>
<a id="page35"></a>
<div class="chapterHead">
<h2 class="chapterNumber"><span class="xrefInternal"><a href="#/xhtml/contents#ch_06"><span class="bold"><em class="italic">chapter 6</em></span></a></span></h2>
<p class="centerImage"><img alt="image" src="images/35.jpg"/></p>
<h2 class="chapterTitle">12:34 <span class="smallCaps">P.M.</span></h2></div>
<div class="chapterBody">
<a id="page36"></a>
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords">A van skidded</span> out of control…wheels lifting off concrete…flipping.</p>
<p class="para">Joaquin saw a woman flailing inside the van, her eyes wide with horror. He thought he could smell the sparks flying off the vehicle as it scraped across the concrete. Then he heard a squeal, and turned to see a Volvo hurtling toward them.</p>
<p class="para">“Gonna kill kill kill kill kill the poor: Tonight,” Biafra howled in his ears.</p>
<p class="para">His voice made everything seem like it was happening in slow motion. A strange apathy overcame him. He found himself studying the Volvo driver’s face as it careened toward him. It was a pleasant face, only slightly marred by the rictus of fear. It looked familiar. Did he know this person? he wondered. No, he told himself, it must be some kind of “future memory” without really knowing what that meant.</p>
<p class="para">In this expanded moment he thought about a lot of odd things. He realized the accident meant they wouldn’t get to the hospital in time to visit his grandmother. This would delay them for hours. Bummer. Then he thought about telling this story to Claudia. She was deadly afraid of car accidents. She would be scared as he described it, then he could console her…console her with sex. It would work, he knew it.</p>
<p class="para">Oh, right, he thought, I’m about to be in an accident. The notion seemed distant, remote. I could be disfigured. Would Claudia still love me? Would she still want me with a face full of scars?</p>
<p class="para">Could she be that superficial? Maybe. Joaquin had no idea how she’d react. What if he injured his hands or fingers? How long would it be be<a id="page37"></a>fore he could stroke a female body, or his guitar? What if he never could? He hoped the accident wouldn’t affect his mother’s promise to buy him a guitar, even if it was just a cheap one. In <em class="italic">Guitar Player</em> magazine he’d seen an ad for a store in suburban Houston where they sold used Fenders at unbelievable prices. He’d written the address down on a piece of paper that he put in his pocket.</p>
<p class="para">Maybe he’d at least get a Fender. Not the cheap Japanese job he’d almost settled on.</p>
<p class="para">He’d forgotten about writing down that address.</p>
<p class="para">Why had he forgotten?</p>
<p class="para">The moment this thought crossed his mind, a sound like a thousand power chords filled his ears. Bits of twisted metal flew at him from every direction.</p>
<p class="para">Oh, right, he remembered, I’m about to be in an accident.</p>
<p class="para">What’s happened to gravity? he wondered.</p>
<p class="para">Everything went black.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter06.vue?4f0c34a4